(function () {
  'use strict';

  var LS_KEY = 'hoa_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(LS_KEY)) || []; }
    catch (e) { return []; }
  }

  function setList(handles) {
    try { localStorage.setItem(LS_KEY, JSON.stringify(handles)); }
    catch (e) {}
  }

  function isWishlisted(handle) {
    return getList().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var list = getList();
    var idx = list.indexOf(handle);
    if (idx === -1) {
      list.push(handle);
    } else {
      list.splice(idx, 1);
    }
    setList(list);
    return idx === -1; // true = added
  }

  function syncButton(btn) {
    var handle = btn.dataset.productHandle;
    if (!handle) return;
    var active = isWishlisted(handle);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? 'Von Wunschliste entfernen' : 'Auf Wunschliste');
  }

  function syncAllButtons() {
    document.querySelectorAll('.hoa-wl-btn').forEach(syncButton);
  }

  function attachButtons() {
    document.querySelectorAll('.hoa-wl-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.dataset.productHandle;
        if (!handle) return;
        toggle(handle);
        syncButton(btn);
        btn.classList.remove('hoa-wl-btn--pop');
        void btn.offsetWidth; // reflow to restart animation
        btn.classList.add('hoa-wl-btn--pop');
        updateWishlistCount();
      });
    });
  }

  function updateWishlistCount() {
    var count = getList().length;
    document.querySelectorAll('[data-wl-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ----------------------------------------------------------------
     Wishlist page rendering
     ---------------------------------------------------------------- */
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function renderCard(product) {
    var img = product.featured_image
      ? product.featured_image.replace('_{width}x', '_400x')
      : '';
    var price = formatMoney(product.price);
    var url = '/products/' + product.handle;

    return '<div class="hoa-wl-card-wrap">' +
      '<a class="hoa-wl-card" href="' + url + '">' +
        '<div class="hoa-wl-card__img-wrap">' +
          (img ? '<img class="hoa-wl-card__img" src="' + img + '" alt="' + (product.title || '') + '" loading="lazy">' : '') +
        '</div>' +
        '<div class="hoa-wl-card__body">' +
          '<p class="hoa-wl-card__title">' + (product.title || '') + '</p>' +
          '<p class="hoa-wl-card__price">' + price + '</p>' +
        '</div>' +
      '</a>' +
      '<button class="hoa-wl-card__remove" data-remove-handle="' + product.handle + '" type="button">Entfernen</button>' +
    '</div>';
  }

  function renderEmpty(container) {
    container.innerHTML =
      '<div class="hoa-wishlist__empty">' +
        '<span class="hoa-wishlist__empty-icon">🤍</span>' +
        '<p class="hoa-wishlist__empty-title">Deine Wunschliste ist leer</p>' +
        '<p class="hoa-wishlist__empty-sub">Speichere deine Lieblingsprodukte mit dem Herz-Symbol.</p>' +
        '<a href="/collections/all" class="hoa-wishlist__empty-link">Produkte entdecken</a>' +
      '</div>';
  }

  function loadWishlistPage() {
    var grid = document.getElementById('hoa-wl-grid');
    var countEl = document.getElementById('hoa-wl-count');
    if (!grid) return;

    var handles = getList();
    if (countEl) countEl.textContent = handles.length + ' Produkt' + (handles.length === 1 ? '' : 'e');

    if (handles.length === 0) {
      renderEmpty(grid);
      return;
    }

    var fetched = [];
    var pending = handles.length;

    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (product) fetched.push(product);
        })
        .catch(function () {})
        .finally(function () {
          pending--;
          if (pending === 0) renderGrid(grid, fetched, countEl, handles);
        });
    });
  }

  function renderGrid(grid, products, countEl, handles) {
    if (products.length === 0) {
      renderEmpty(grid);
      return;
    }
    /* Preserve LS order */
    products.sort(function (a, b) {
      return handles.indexOf(a.handle) - handles.indexOf(b.handle);
    });
    if (countEl) countEl.textContent = products.length + ' Produkt' + (products.length === 1 ? '' : 'e');
    grid.innerHTML = products.map(renderCard).join('');

    grid.querySelectorAll('[data-remove-handle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var handle = btn.dataset.removeHandle;
        var list = getList();
        var idx = list.indexOf(handle);
        if (idx !== -1) { list.splice(idx, 1); setList(list); }
        var wrap = btn.closest('.hoa-wl-card-wrap');
        if (wrap) wrap.remove();
        var remaining = grid.querySelectorAll('.hoa-wl-card-wrap').length;
        if (remaining === 0) renderEmpty(grid);
        if (countEl) countEl.textContent = remaining + ' Produkt' + (remaining === 1 ? '' : 'e');
        syncAllButtons();
      });
    });
  }

  /* ----------------------------------------------------------------
     Init
     ---------------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    syncAllButtons();
    attachButtons();
    updateWishlistCount();
    loadWishlistPage();
  });
})();
